import AgileMethodology from './AgileMethodology';

export default AgileMethodology;
